import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ams-inventory",
  "use": "icon-ams-inventory-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ams-inventory\"><defs><style type=\"text/css\"></style></defs><path d=\"M459.17184 129.21856c-229.26848 0-394.6496 185.856-394.6496 415.1296 0 229.26336 185.86112 415.1296 415.1296 415.1296 229.26848 0 415.1296-165.38112 415.1296-394.6496h-435.6096v-435.6096z m105.65632-64.69632v394.6496h394.6496c0-229.26848-165.38112-394.6496-394.6496-394.6496z\" p-id=\"2676\" fill=\"#3CA0E9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol